export const filters = {
    priceFormat:  function (amount, decimalCount = 2, decimal = ".", thousands = ",") {
        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

            const negativeSign = amount < 0 ? "-" : "";

            let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;

            return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
        } catch (e) {
            return 0.00;
        }
    },
    withCurrency: function (value, currency, zero = false) {
        if (!value && !zero) {
            return '';
        }
        currency = currency || {position: 1, sign: '£'};

        return currency.position > 1 ? value + currency.sign : currency.sign + value;
    },
    ucfirst:      function (str) {
        if (typeof str !== 'string') {
            return '';
        }

        str = str.split(' ');

        for (var i = 0, x = str.length; i < x; i++) {
            str[i] = str[i][0].toUpperCase() + str[i].substr(1);
        }

        return str.join(' ');
    },
    dateFormat: {
        function (value) {
            if (!value) {
                return '';
            }

            return moment(value).format('DD/MM/YYYY');
        }
    },
    joinByKey: function (objects, key = 'name', separator = ', ') {
        return objects.map(o => o[key]).join(separator);
    }
};
